export const SUPPORTERS_INVESTING_RANGE_LIMIT = 4;
export const SUPPORTERS_INVESTING_RANGE_META = "investingRange";

export const SUPPORTERS_TERMS_OF_USE_URL = "https://abaca.app/terms-of-use";
export const SUPPORTERS_PRIVACY_POLICY_URL = "https://abaca.app/privacy-policy";
